import { useTranslation } from 'next-i18next';

import { useMemo } from 'react';

import { formatHelpers } from '@nocowanie/core/helpers';

import { PetType } from '@app/models/elastic-search';
import * as accommodationStaticSlice from '@app/state/slices/accommodation-static.slice';
import { useAppSelector } from '@app/state/state';

export const PetsInformation = () => {
    const { t } = useTranslation('accommodation', {
        keyPrefix: 'stayRules.pets',
    });

    const petsPolicy = useAppSelector(accommodationStaticSlice.selectors.selectPetsPolicy);
    const currency = useAppSelector(accommodationStaticSlice.selectors.selectCurrency);

    const petsInfo = useMemo(() => {
        if (!petsPolicy) {
            return t('notAllowed');
        }

        const formattedPrice = formatHelpers.price(petsPolicy.price, currency);

        const hasDogs = petsPolicy.types.includes(PetType.Dogs);
        const hasCats = petsPolicy.types.includes(PetType.Cats);

        const typesText =
            hasDogs && hasCats ? t('dogsAndCats') : hasDogs ? t('onlyDogs') : t('onlyCats');

        const weightText = petsPolicy.weightLimit
            ? ` ${t('weightLimit', { value: petsPolicy.weightLimit })}`
            : '';

        const priceText =
            petsPolicy.price > 0
                ? ` ${t('priceInfo', { value: formattedPrice })}`
                : ` ${t('noPetsFee')}`;

        return `${t('accepted')} ${typesText}${weightText}.${priceText}`;
    }, [petsPolicy, currency, t]);

    return <>{petsInfo}</>;
};
